import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AlertService } from '@app/shared/components/organisms/alert/alert.service';
import { MESSAGES } from '@app/shared/utils/messages';
import { AuthService } from './auth.service';
import { cognitoRedirectUrl } from '@app/shared/auth/auth.config';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  constructor(
    private router: Router,
    private authService: AuthService,
    private alertService: AlertService,
  ) {}

  canActivate(): boolean {
    if (!this.authService.isLoggedIn()) {
      window.location.href = cognitoRedirectUrl;
      return false;
    }

    if (this.authService.isSessionExpired()) {
      // refresh
      this.authService.refreshToken().subscribe({
        next: () => {
          this.alertService.info(MESSAGES.RECONNECTION, {
            icon: 'refresh',
            duration: 3000,
          });
        },
      });
      return false;
    }

    return true;
  }
}
